import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const CUST_API_BASE = `${BACKEND_URL}/api`;
export const CUST_TOKEN_KEY = "rescigo_cust_token";
export const CUST_USER_KEY = "rescigo_cust_user";

export const custApi = axios.create({
  baseURL: CUST_API_BASE,
  timeout: 20000,
});

custApi.interceptors.request.use((config) => {
  const token = localStorage.getItem(CUST_TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

custApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && window.location.pathname.startsWith("/me") &&
        window.location.pathname !== "/me/login") {
      localStorage.removeItem(CUST_TOKEN_KEY);
      localStorage.removeItem(CUST_USER_KEY);
      window.location.href = "/me/login";
    }
    return Promise.reject(err);
  },
);

export function formatErr(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join("; ");
  return String(d);
}
